'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _pikaday = require('pikaday');

var _pikaday2 = _interopRequireDefault(_pikaday);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

datepickerDirective.$inject = ['$document', 'DutchHolidaysService'];


var _module = _angular2.default.module('cb.ui-components.datepicker', []);

_module.directive('cbDatepicker', datepickerDirective);

exports.default = _module;

//
// Datepicker directive
//
// Add cb-datepicker to a input or calendar button.
//
// Options:
//
// cb-datepicker-input-id: The ID of the input field. This is only needed if you want to activate the picker with a button.
// cb-datepicker-container-id: The ID of the datepicker container This is only needed for lift&shift in Sitecore, where styling is only applied when the datepicker is loaded within a legacy div.
// cb-datepicker-container-class: The class of the datepicker container. This is only needed for lift&shift in Sitecore, where styling is only applied when the datepicker is loaded within a legacy div.
//                             the container should be somewhere in the parents, parent, level of the input.

// NOTE: cb-datepicker-container-clas will override cb-datepicker-container-id when both are used.

// cb-no-past:
//

function datepickerDirective($document, DutchHolidaysService) {
    var i18n = {
        previousMonth: 'Vorige maand',
        nextMonth: 'Volgende maand',
        months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
        weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
        weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
    };

    return {
        restrict: 'A',
        link: DatepickerLink
    };

    function DatepickerLink(scope, element, attrs) {
        var field = element[0];
        var trigger = element[0];
        var currentYear = void 0;

        if (attrs.cbDatepickerInputId) {
            field = $document.querySelector('#' + attrs.cbDatepickerInputId);
        }

        if (attrs.cbDatepickerTriggerId) {
            trigger = $document.querySelector('#' + attrs.cbDatepickerTriggerId);
        }

        var config = {
            i18n: i18n,
            format: 'DD-MM-YYYY',
            firstDay: 1, // Monday as the first day of the week
            field: field,
            trigger: trigger,
            onSelect: function onSelect() {
                field.focus(); // this causes the value to be set in combination with cb-blur
            }
        };

        if (_angular2.default.isDefined(attrs.cbDateNoPast)) {
            config['minDate'] = new Date();
        }

        if (_angular2.default.isDefined(attrs.cbTheme)) {
            config['theme'] = attrs.cbTheme;
        }

        if (_angular2.default.isDefined(attrs.cbDateFirstDayOfMonth)) {
            config['disableDayFn'] = function (date) {
                return date.getDate() !== 1;
            };
        }

        if (_angular2.default.isDefined(attrs.cbDateMin)) {
            config['minDate'] = (0, _moment2.default)(attrs.cbDateMin, ['DD-MM-YY', 'DD-MM-YYYY', 'DD-MM']).toDate();
            config['defaultDate'] = (0, _moment2.default)(attrs.cbDateMin, ['DD-MM-YY', 'DD-MM-YYYY', 'DD-MM']).toDate();
        }

        if (_angular2.default.isDefined(attrs.cbDateMax)) {
            config['maxDate'] = (0, _moment2.default)(attrs.cbDateMax, ['DD-MM-YY', 'DD-MM-YYYY', 'DD-MM']).toDate();
        }

        if (_angular2.default.isDefined(attrs.cbDateMaxMonths)) {
            config['maxDate'] = (0, _moment2.default)(new Date()).add(attrs.cbDateMaxMonths, 'months').toDate();
        }

        if (_angular2.default.isDefined(attrs.cbDateNoWeekends)) {
            config['disableWeekends'] = true;
        }

        if (_angular2.default.isDefined(attrs.cbDateNoSundays)) {
            config['disableDayFn'] = function (date) {
                return date.getDay() === 0;
            };
        }

        if (_angular2.default.isDefined(attrs.cbDatepickerContainerId) && _angular2.default.isDefined(document.querySelector('#' + attrs.cbDatepickerContainerId))) {
            config['container'] = document.querySelector('#' + attrs.cbDatepickerContainerId);
        }

        if (_angular2.default.isDefined(attrs.cbDatepickerContainerClass)) {
            var specificContainer = trigger.parentElement.parentElement.querySelectorAll('.' + attrs.cbDatepickerContainerClass)[0];
            if (_angular2.default.isDefined(specificContainer)) {
                config['container'] = specificContainer;
            }
        }

        new _pikaday2.default(config);
    }
};

datepickerDirective.$inject = ['$document', 'DutchHolidaysService'];


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-datepicker.directive.js
// module id = 860
// module chunks = 0